import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './components/AuthProvider';
import AuthenticatedApp from './components/AuthenticatedApp';
import { setInstrumentationKey, getToken, setUserInfo } from './components/common';
import { getInstrumentationKey } from './components/services';

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <AuthenticatedApp>
        <App />
      </AuthenticatedApp>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
